import "./DeleteDialog.css";

const DeleteDialog = ({ showDialog, setShowDialog, onDelete, deleteLoading }) => {
  const handleConfirm = () => {
    if (onDelete) {
      onDelete();
    }
    setShowDialog(false);
  };

  const handleCancel = () => {
    setShowDialog(false);
  };

  if (!showDialog) return null;

  return (
    <div className="overlay">
      <div className="dialog-box">
        <h2 className="dialog-title">Delete Note</h2>
        <p className="dialog-message">Are you sure want to delete the note?</p>
        <div className="dialog-actions">
          <button className="cancel-button-dialog" onClick={handleCancel}>
            Cancel
          </button>
          <button className="confirm-button" onClick={handleConfirm}>
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteDialog;
